<script>
    import Caja from "../../UI/Caja.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Loading from "../../UI/Loading.svelte";
    import {horasTrabajadas} from '../../../Modelos/Trabajador';
    import Duracion from "../../UI/Duracion.svelte";
    import Boton from "../../UI/Boton.svelte";
    import Diferencia from '../../UI/Diferencia.svelte';

    export let dia;
    export let tipo;

    $: horas = dia.tiempoTotal || (dia && dia.horas && horasTrabajadas(dia.horas));
</script>

<style>
    .duracion {
        text-align: center;
        display: flex;
        width: 100%;
        height: 100%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .previstas {
        margin-bottom: .5em;
    }

    .diferencia {
        margin-top: .5em;
        font-size: 2em;
    }

    .informacion {
        font-size: 1.25em;
        text-transform: uppercase;
        letter-spacing: .15em;
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>Diferencia</Subtitulo>
    </div>

    <div slot="botones">
        <Boton icono="print">Imprimir</Boton>
    </div>

    <div class="duracion">
        {#if tipo && tipo.duracion}
            <div class="previstas">
                <Duracion minutos={tipo.duracion}/>
                previstas
            </div>

            <div class="trabajadas">
                <Duracion minutos={horas}/>
                trabajadas
            </div>

            <div class="diferencia">
                <Diferencia previsto={tipo.duracion} trabajado={horas} iconoSiBien="check"/>
            </div>
        {:else}
            <div class="informacion">
                Festivo
            </div>
        {/if}
    </div>
</Caja>